<core-helpers-box-loading [hidden]="status == STATUS_DONE"></core-helpers-box-loading>

<div class="feedback-content-main-files" [ngClass]="{'with-overlay': modalView == MODAL_VIEW_FILES_SIGNED_ERROR }">
    <core-layout-modal-feedback class="modal-feedback" *ngIf="modalView == MODAL_VIEW_FILES_SIGNED_ERROR"
        [type]="'fail'"
        [message]="'Error'"
        [text]="'There was a problem getting your file. Please try again. If the error persists, please reach out to our support team through the Help Me button.'"
        [buttonText]="'Discard'"
        (action)="dismmisError($event)">
    </core-layout-modal-feedback>
    <div class="files" *ngIf="status == STATUS_DONE">
        <!-- show files with notes -->
        <core-files-list-notes
            [files]="files"
            [notes]="notesCounter"
            [menu]="menu"
            [context]="context"
            (menuClick)="onMenuClick($event)"
            (actionClick)="openNotes($event)"
            (iconDownloadClick)="onActionDownloadClick($event)"
        ></core-files-list-notes>
    </div>
</div>
<div class="feedback-content-preview-file" *ngIf="files.length > 0" >
    <div *ngFor="let file of files">
        <core-pdf-annotations-viewer 
            *ngIf="selectedFile != null && selectedFile.id == file.id"
            [file]="selectedFile" 
            [annotationsAllowed]="canCreateNotes" 
            [urlAnnotationsPrefix]="prefixUrl"
            [context]="context"
            [user]="user"
            (saved)="onSavedAnnotations($event)"
            >
        </core-pdf-annotations-viewer>
    </div>
</div>
